import React, {
    useEffect,
    useState
 } from "react";
import { 
    Button,
    Divider,
    Input,
    Spacer,
    Table,
    TableHeader,
    TableColumn,
    TableBody,
    TableRow,
    TableCell
} from "@nextui-org/react";
import swal from "sweetalert2";
import Ajax from "../inc/js/Ajax";
import { Trophy } from "../inc/images/svgs";
import {
    HelmetWrapper
} from "../inc/js/Helper"


export default function PeoplesChoice() {
    const [contestantData, setContestantData] = useState(null);
    const [eventName, setEventName] = useState(null);
    const [guestInput, setGuestInput] = useState("");
    const [guestInfo, setGuestInfo] = useState([]);
    const [qrCode, setQRCode] = useState(null);
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [votes, setVotes] = useState(null);
    
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const code = queryParams.get("code") || localStorage.getItem("code");
        const name = queryParams.get("event") || localStorage.getItem("event");

        if (code) {
            localStorage.setItem('code', code);
            localStorage.setItem('event', name);
            setQRCode(code);
            setEventName(name);

            if (window.history.replaceState) {
                window.history.replaceState(null, null, window.location.pathname);
            }

            Ajax.request({
                url:"/JudgeAutos/authenticatePeoplesChoice",
                jsonData:{code:code},
                success:function(reply) {
                    if (reply.data === "reload") {
                        window.location.reload();
                    }
                    setGuestInfo(reply.data);
                }
            })
        } else {
            swal.fire({
                title: "Whoopsie Daisy",
                text: "A valid code must be provided",
                icon: "error",
                didClose: () => {
                    document.location.href = "/"
                }
            })
        }
    }, []);

    const readContestantData = () => {
        if (/^\d+$/.test(guestInput)) {
            Ajax.request({
                url:"/JudgeAutos/readContestantData",
                jsonData:{
                    registrationNumber:guestInput,
                    code:qrCode
                },
                success:function(reply) {
                    setContestantData(reply.data.contestant);
                    setVotes(reply.data.votes);

                    if (reply.data.votes === 1) {
                        setSelectedPosition(1);
                    }
                }
            })
        } else {
            swal.fire({
                title: "Whoopsie Daisy",
                text: `Please enter a contestant's number`,
                icon: "error"
            })
        }
    }

    const submitVote = () => {
        if (selectedPosition > votes || selectedPosition <= 0) {
            swal.fire({
                title: "Whoopsie Daisy",
                text: `Invalid Place selection`,
                icon: "error"
            })
            return;
        }

        Ajax.request({
            url:"/JudgeAutos/SubmitPeoplesVote",
            jsonData:{
                registrationId: contestantData.registrationId,
                registrationNumber: guestInput,
                rank: selectedPosition,
                code: qrCode
            },
            success:function(reply) {
                swal.fire({
                    title: "Success!",
                    text: `${reply.data}`,
                    icon: "success",
                    didClose: () => {
                        if (votes > 1) {
                            window.location.reload();
                        } else {
                            document.location.href = "/EventView"
                        }
                    }
                })
            }
        })
    }

    return (
        <>
            <HelmetWrapper
                title="JudgeAutos - People's Choice"
                description="People's Choice allows guests to submit votes for their top 1, 5, or 10 contestants"
                url="/PeoplesChoice"
            />
        
            <div className="mx-auto w-full sm:w-2/3 text-center">
                <div className="grid grid-cols-1 gap-4 m-4 p-1">
                    <h2 className="text-5xl">{eventName}</h2>
                    <h1 className="text-2xl">People's Choice</h1>
                </div>
                <Divider className="w-full" />
                <Spacer y={3} />
                {!contestantData ? (
                    <>
                        {guestInfo.length > 0 &&
                            <span>Thanks for being part of the show! You are guest {guestInfo[0].guestNumber} of {guestInfo[0].totalGuests} and may vote for <strong>{guestInfo[0].votesAllowed}</strong> contestants.
                            <Spacer y={2} />
                            Enter a contestant's number below to get started.</span>
                        }
                        
                        <Spacer y={5} />
                        
                        <Input 
                            variant="bordered"
                            className="w-24 mx-auto"
                            classNames={{
                                inputWrapper: "aspect-square h-24 mx-auto",
                                input: "h-full text-center text-3xl font-semibold"
                            }}
                            type="tel"
                            value={guestInput}
                            onChange={(e) => {setGuestInput(e.target.value)}}
                        />
                        <Spacer y={3} />
                        <Button
                            color="primary"
                            variant="solid"
                            size="lg"
                            className="w-2/3 sm:w-1/3 text-xl"
                            onPress={() => readContestantData()}
                        >
                            View
                        </Button>
                        <Spacer y={5} />
                        {guestInfo[0]?.rank > 0 &&
                            <>
                                <Divider className="w-3/4 mx-auto" />
                                <Spacer y={5} />
                                <Table
                                    isStriped
                                    aria-label="Votes"
                                    layout="fixed"
                                >
                                    <TableHeader>
                                        <TableColumn align="center">Rank</TableColumn>
                                        <TableColumn align="center">Contestant</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {guestInfo.map((data, index) => (
                                            <TableRow key={index} className="h-16">
                                                <TableCell className="h-full">
                                                    <div className="flex h-full items-center justify-center overflow-hidden">
                                                        <Trophy
                                                            size="32"
                                                            number={data.rank}
                                                            color={
                                                                data.rank === 1 ? "text-yellow-400" :
                                                                data.rank === 2 ? "text-gray-300" :
                                                                data.rank === 3 ? "text-amber-600" :
                                                                "text-blue-500"
                                                            }
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell className="h-full">
                                                    <div className="flex h-full items-center justify-center text-center overflow-hidden">
                                                        {data.registrationNumber}: {[data.color, data.year, data.make, data.model].filter(Boolean).join(' ')}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </>
                        }
                    </>
                ) : (
                    <>
                        <div>
                            <div className="grid grid-cols-2 gap-2">
                                {Object.entries(contestantData).map(([key, data]) => (
                                    key !== "registrationId" && (
                                        <Input
                                            isReadOnly
                                            key={key}
                                            label={key}
                                            variant="bordered"
                                            classNames={{input: "text-[16px]"}}
                                            size="lg"
                                            value={data}
                                        />
                                    )
                                ))}
                            </div>
                            <Spacer y={5} />
                            {votes > 1 &&
                                <Divider className="w-3/4 mx-auto" />
                            }
                            <Spacer y={5} />
                            <div className="text-center">
                                {votes > 1 &&
                                    <h3 className="text-2xl font-semibold mb-4">
                                        Select Place
                                    </h3>
                                }
                                <div className={`grid gap-3 w-full ${
                                    votes === 10 ? 'grid-cols-4 sm:grid-cols-10' : 
                                    votes === 5 ? 'grid-cols-3 sm:grid-cols-5' : 
                                    'grid-cols-1'
                                }`}>
                                    {votes > 1 && Array.from({ length: votes }, (_, i) => i + 1).map((position) => (
                                        <Button
                                            key={position}
                                            size="md"
                                            color={selectedPosition === position ? "primary" : "default"}
                                            variant={selectedPosition === position ? "solid" : "bordered"}
                                            onPress={() => setSelectedPosition(position)}
                                            className="text-xl font-bold aspect-square p-1"
                                        >
                                            <Trophy
                                                size="48"
                                                number={position}
                                                color={
                                                    position === 1 ? "text-yellow-400" :
                                                    position === 2 ? "text-gray-300" :
                                                    position === 3 ? "text-amber-600" :
                                                    "text-blue-500"
                                                }
                                            />
                                        </Button>
                                    ))}
                                </div>
                                <Spacer y={4} />
                                <Button
                                    variant="solid"
                                    color="primary"
                                    size="lg"
                                    isDisabled={!selectedPosition}
                                    onPress={submitVote}
                                >
                                    Submit Vote
                                </Button>
                            </div>
                        </div>

                    </>
                )}
            </div>
        </>
    );
}